import React, { useEffect, useState } from "react";
import apiUrl from "../Apiurl";


function OrdiniInQuestoStatoSelfUpdating(props) {


    const stato = props.stato;

    const [listaOrdini, setListaOrdini] = useState([])
    //const [ordRefr, setOrdRefr] = useState(arrayPerRefresh.length)

    const [time, setTime] = useState(Date.now());

    useEffect(() => {
        const interval = setInterval(() => setTime(Date.now()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    

    useEffect(() => {
        //copiare anche qui la stessa cosa che fa la funz da tradurre o non far visualizzare niente
        console.log("fetcho")
        fetch(apiUrl + "/logistica/sparaOrdini/ricercaOrdiniStato/" + stato)
            .then(resp => resp.json())
            .then(data => setListaOrdini(data))
    }, [time]);




    return (
        <div className="tc">
            <h4>Ordini in questo stato</h4>
            <div className="colonne">
                {listaOrdini && listaOrdini.map((ordine) => <p className="elementoColonna">{ordine.ordinePS}</p>)}
            </div>
        </div>
    )

}

export default OrdiniInQuestoStatoSelfUpdating;




